module.exports = __webpack_public_path__ + "img/67ne.524eb403.svg";